// extracted by mini-css-extract-plugin
export default {"subTitle":"index_subTitle__46yo5","cancel":"index_cancel__Hh1sL"};